export default "__VITE_ASSET__ZW9XadFG__"